export default function FortuneWheelDisk({
  slices = [],
  turn = 0,
  spinning = false,
  size = 280,
  hubLabel = "SPIN",
  testId = "fortune-wheel-disk",
}) {
  const n = Math.max(slices.length, 1);
  const cx = 50;
  const cy = 50;
  const r = 50;
  const parts = slices.map((s, i) => {
    const a0 = (i / n) * 2 * Math.PI - Math.PI / 2;
    const a1 = ((i + 1) / n) * 2 * Math.PI - Math.PI / 2;
    const large = 2 * Math.PI / n > Math.PI ? 1 : 0;
    const x0 = cx + r * Math.cos(a0);
    const y0 = cy + r * Math.sin(a0);
    const x1 = cx + r * Math.cos(a1);
    const y1 = cy + r * Math.sin(a1);
    const mid = ((i + 0.5) / n) * 2 * Math.PI - Math.PI / 2;
    const tx = cx + r * 0.62 * Math.cos(mid);
    const ty = cy + r * 0.62 * Math.sin(mid);
    const rot = (mid * 180) / Math.PI + 90;
    return {
      key: i,
      color: s.color || (i % 2 ? "#C9A07A" : "#E8D5C4"),
      label: s.label || "",
      d: `M ${cx} ${cy} L ${x0.toFixed(3)} ${y0.toFixed(3)} A ${r} ${r} 0 ${large} 1 ${x1.toFixed(3)} ${y1.toFixed(3)} Z`,
      tx, ty, rot,
    };
  });

  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <div
        className="absolute left-1/2 -top-1 z-20 -translate-x-1/2"
        aria-hidden
      >
        <div className="w-0 h-0 border-l-[9px] border-r-[9px] border-t-[16px] border-l-transparent border-r-transparent border-t-[#3D2B1F] drop-shadow" />
      </div>
      <div
        className="absolute inset-0 rounded-full shadow-[0_12px_40px_rgba(61,43,31,0.28)] ring-[10px] ring-[#3D2B1F]"
        style={{
          transform: `rotate(${turn}deg)`,
          transition: spinning ? "transform 4s cubic-bezier(0.12, 0.7, 0.1, 1)" : "none",
        }}
        data-testid={testId}
      >
        <svg viewBox="0 0 100 100" className="w-full h-full rounded-full overflow-hidden">
          {parts.map((p) => (
            <g key={p.key}>
              <path d={p.d} fill={p.color} stroke="#fff" strokeWidth="0.35" />
              <text
                x={p.tx}
                y={p.ty}
                fill="#3D2B1F"
                fontSize={n > 6 ? 3.1 : 3.6}
                fontWeight="700"
                textAnchor="middle"
                dominantBaseline="middle"
                transform={`rotate(${p.rot} ${p.tx} ${p.ty})`}
                style={{ fontFamily: "ui-sans-serif, system-ui, sans-serif" }}
              >
                {(p.label || "").slice(0, 14)}
              </text>
            </g>
          ))}
        </svg>
      </div>
      <div className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 w-[22%] h-[22%] rounded-full bg-[#3D2B1F] text-white flex items-center justify-center text-center shadow-inner ring-2 ring-[#E8D5C4]">
        <span className="text-[9px] sm:text-[10px] font-bold leading-tight tracking-wide px-1">{hubLabel}</span>
      </div>
    </div>
  );
}
